module.exports = __webpack_public_path__ + "img/cthulhu_meta33matrix.9210a26.png";